import { useLocation } from "react-router"

const useIsAdminRoute = () => {
  const navigation = useLocation()

  return navigation.pathname.split("/").includes("admin")
}

export default useIsAdminRoute
